"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecurities = void 0;
const json_1 = require("@stoplight/json");
const pickBy = require("lodash.pickby");
const guards_1 = require("../guards");
const utils_1 = require("../utils");
const guards_2 = require("./guards");
function getSecurities(document, operationSecurities) {
    var _a;
    const definitions = (_a = document.components) === null || _a === void 0 ? void 0 : _a.securitySchemes;
    if (!(0, json_1.isPlainObject)(definitions))
        return [];
    return (Array.isArray(operationSecurities) ? operationSecurities : document.security || []).map(operationSecurity => {
        return (0, utils_1.entries)(operationSecurity)
            .map(([opScheme, scopes]) => {
            const definition = definitions[opScheme];
            if (!(0, guards_2.isSecurityScheme)(definition))
                return;
            if (definition.type === 'oauth2') {
                return [
                    opScheme,
                    {
                        ...definition,
                        flows: Object.fromEntries((0, utils_1.entries)(definition.flows).map(([name, flow]) => [
                            name,
                            {
                                ...flow,
                                scopes: pickBy(flow === null || flow === void 0 ? void 0 : flow.scopes, (_val, key) => scopes === null || scopes === void 0 ? void 0 : scopes.includes(key)),
                            },
                        ])),
                    },
                ];
            }
            return [opScheme, definition];
        })
            .filter(guards_1.isNonNullable);
    });
}
exports.getSecurities = getSecurities;
//# sourceMappingURL=accessors.js.map